import React from "react";
import { findObjectUseCase } from "../../../../usecases/object";
import DashboardCard from "../../../../components/DashboardCard";

const defaultProps = {
  where: {},
};

function Count({
  collection,
  label,
  icon,
  where,
  labelAction,
  val,
  percentage,
  bg,
  ...props
}) {
  return (
    <DashboardCard
      icon={icon || "bi bi-pie-chart"}
      // style={{ backgroundColor: "green" }}
      label={
        label || <span className="text-capitalize">Total {collection}</span>
      }
      labelAction={labelAction || "VIEW"}
      value={val}
      percentage={percentage}
      bg={bg}
      {...props}
    />
  );
}

Count.defaultProps = defaultProps;
export default Count;
